import { api } from './client';

/** Una voce di subappalto del preventivo della commessa, con quanto è già affidato. */
export interface SubappaltoDaAffidare {
  rigaPreventivoId: string;
  capitolo: string | null;
  descrizione: string;
  codiceFornitoreMago: string | null;
  fornitore: string | null;
  preventivato: number;
  giaAffidato: number;
  daAffidare: number;
}

export interface NuovoSubappalto {
  commessaId: string;
  codiceFornitoreMago: string;
  descrizione: string;
  importo: number;
  rigaPreventivoId?: string | null;
  fornitore?: string | null;
  dataInizio?: string | null;
  dataFine?: string | null;
  note?: string | null;
}

export interface CorrezioneSubappalto {
  codiceFornitoreMago: string;
  descrizione: string;
  importo: number;
  fornitore?: string | null;
  dataInizio?: string | null;
  dataFine?: string | null;
  note?: string | null;
}

export interface DettaglioSubappalto {
  id: string;
  numero: string | null;
  stato: string;
  codiceSede: string;
  commessaId: string;
  commessa: string | null;
  cliente: string | null;
  preventivoId: string | null;
  preventivo: string | null;
  rigaPreventivoId: string | null;
  rigaPreventivo: string | null;
  preventivato: number | null;
  codiceFornitoreMago: string;
  fornitore: string | null;
  descrizione: string;
  importo: number;
  dataInizio: string | null;
  dataFine: string | null;
  note: string | null;
  confermatoIl: string | null;
  motivoAnnullamento: string | null;
  creatoIl: string;
  creatoDa: string;
}

export const subappalti = {
  daAffidare: (commessaId: string) =>
    api.get<SubappaltoDaAffidare[]>(`/subappalti/da-affidare/${commessaId}`),
  crea: (nuovo: NuovoSubappalto) => api.post<DettaglioSubappalto>('/subappalti', nuovo),
  leggi: (id: string) => api.get<DettaglioSubappalto>(`/subappalti/${id}`),
  correggi: (id: string, correzione: CorrezioneSubappalto) =>
    api.put<DettaglioSubappalto>(`/subappalti/${id}`, correzione),
  conferma: (id: string) => api.post<DettaglioSubappalto>(`/subappalti/${id}/conferma`, {}),
  concludi: (id: string) => api.post<DettaglioSubappalto>(`/subappalti/${id}/concludi`, {}),
  annulla: (id: string, motivo: string) =>
    api.post<DettaglioSubappalto>(`/subappalti/${id}/annulla`, { motivo }),
};
